import { useState } from "react";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Stats from "@/components/landing/Stats";
import Modules from "@/components/landing/Modules";
import Pricing from "@/components/landing/Pricing";
import Sessions from "@/components/landing/Sessions";
import Centers from "@/components/landing/Centers";
import Gallery from "@/components/landing/Gallery";
import Testimonials from "@/components/landing/Testimonials";
import FAQ from "@/components/landing/FAQ";
import CTAFinal from "@/components/landing/CTAFinal";
import ContactForm from "@/components/landing/ContactForm";
import Footer from "@/components/landing/Footer";
import LeadDialog from "@/components/landing/LeadDialog";
import StickyCTA from "@/components/landing/StickyCTA";
import { fbq } from "@/lib/tracking";
import { iclosedUrl } from "@/lib/booking";

export default function Landing() {
  const [dialog, setDialog] = useState({ open: false, source: "call_booking", meta: {} });

  const openDialog = (source, meta = {}) => {
    // "Réserver un appel découverte" → ouvre iClosed avec UTM personnalisé selon le bouton
    if (source === "call_booking") {
      const campaign = meta.campaign || (meta.plan ? `cta-pricing-${meta.plan}` : "cta-generic");
      fbq.schedule({ content_name: "iClosed booking", content_category: campaign });
      window.open(iclosedUrl(campaign), "_blank", "noopener,noreferrer");
      return;
    }
    fbq.initiateCheckout({ content_name: source, content_category: meta.plan || meta.session_label || "general" });
    setDialog({ open: true, source, meta });
  };
  const closeDialog = () => setDialog((d) => ({ ...d, open: false }));

  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <Navbar onCtaClick={openDialog} />
      <main>
        <Hero onCtaClick={openDialog} />
        <Stats />
        <Modules />
        <Pricing onCtaClick={openDialog} />
        <Testimonials />
        <Sessions onCtaClick={openDialog} />
        <Centers />
        <Gallery />
        <FAQ />
        <CTAFinal onCtaClick={openDialog} />
        <ContactForm />
      </main>
      <Footer />
      <LeadDialog
        open={dialog.open}
        onClose={closeDialog}
        source={dialog.source}
        meta={dialog.meta}
      />
      <StickyCTA />
    </div>
  );
}
